import React from "react";
import { Card, Container } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import AffinityGroupList from "./AffinityGroupList";

const ServiceProvider = () => {
  const breadcrumbItems = [
    { title: "AG", link: "" },
    { title: "Affinity Group", link: "/ag/ag" },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb items={breadcrumbItems} />
          <Card className="card_container">
            <AffinityGroupList />
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ServiceProvider;
